import React from 'react';
import {Link} from 'react-router-dom';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import {SignInEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import Icon from 'presentation/icons';
import {StyledTypography} from './styles';

const {alreadyUser} = translations['pt-br'].publicFlow.signUp;
const {signIn} = translations['pt-br'].publicFlow.actionText;

export function GoToLogin() {
	return (
		<Stack gap={2} mt={1}>
			<StyledTypography variant="body1">{alreadyUser}</StyledTypography>
			<Button
				component={Link}
				size="large"
				to={SignInEnum.SIGN_IN}
				state={{goToSignInState: true}}
				variant="outlined"
				endIcon={<Icon name="arrow-right-filled" />}>
				{signIn}
			</Button>
		</Stack>
	);
}
